import React from "react";
import { SvgIcon, SvgIconProps, Box } from "@mui/material";
import canyaLogo from "../../assets/canya_logo.png";
import canyaLogoNoText from "../../assets/canya_logo_no_text.png";
import logoSvg from "../../assets/logo.svg";

export const LogoIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 200 200">
      {/* Teal square with rounded corners */}
      <rect
        x="20"
        y="20"
        width="160"
        height="160"
        rx="30"
        ry="30"
        fill="#2BB3A3"
      />

      {/* Center large figure (dark blue) */}
      <circle cx="100" cy="60" r="25" fill="#174B67" />
      <rect
        x="75"
        y="85"
        width="50"
        height="75"
        rx="25"
        ry="25"
        fill="#174B67"
      />

      {/* Left smaller figure (teal) */}
      <circle cx="50" cy="80" r="15" fill="#2BB3A3" />
      <rect
        x="35"
        y="95"
        width="30"
        height="55"
        rx="15"
        ry="15"
        fill="#2BB3A3"
      />

      {/* Right smaller figure (teal) */}
      <circle cx="150" cy="80" r="15" fill="#2BB3A3" />
      <rect
        x="135"
        y="95"
        width="30"
        height="55"
        rx="15"
        ry="15"
        fill="#2BB3A3"
      />
    </SvgIcon>
  );
};

// This component renders just the logo icon as an <img> using the actual image
export const LogoImage: React.FC<{
  width?: number;
  height?: number;
  noText?: boolean;
}> = ({ width = 80, height = 80, noText = false }) => {
  // Use the actual logo image from assets
  return (
    <Box
      component="img"
      src={noText ? canyaLogoNoText : canyaLogo}
      alt="CanYa Logo"
      sx={{
        width,
        height,
        objectFit: "contain",
        mb: noText ? 0 : 4,
      }}
    />
  );
};

// This component renders the SVG logo directly from the assets folder
export const LogoSvg: React.FC<{ width?: number; height?: number }> = ({
  width = 80,
  height = 80,
}) => {
  return (
    <Box
      component="img"
      src={logoSvg}
      alt="CanYa Logo"
      sx={{
        width,
        height,
        objectFit: "contain",
      }}
    />
  );
};

export const FullLogo: React.FC<{ height?: number; color?: string }> = ({
  height = 40,
  color = "#174B67",
}) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <LogoImage height={height} width={height} />
      <span
        style={{
          marginLeft: height * 0.2,
          fontSize: height * 0.7,
          fontWeight: "bold",
          color: color,
        }}
      ></span>
    </div>
  );
};

export default FullLogo;
